<template>
  <v-select
    :outlined="outlined"
    :flat="flat"
    :solo="solo"
    :menu-props="{ outlined: true }"
    :dense="dense"
    :item-color="itemColor || color"
    :color="color"
    :items="times"
    class="cms-filter-select"
    :item-text="({text}) => $t(`time.${text}`)"
    v-model="time"
    @change="({ text }) => updateQuery({ time: text })"
    return-object
    hide-details
    prepend-inner-icon="mdi-sort-clock-ascending-outline"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    solo: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default () { return 'primary'; },
    },
    itemColor: {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      required: true,
    },
    updateQuery: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState({
      times: state => state.constants.times,
    })
  },
  data() {
    const { value } = this;
    return {
      time: value || { text: 'all', value: null},
    }
  },
  watch: {
    time(newValue, oldValue) {
      if(newValue && newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
    value(newValue) {
      this.time = newValue;
    }
  },
}
</script>